import axios from "axios";

//Administrator panel store module
const adminModule = {
	namespaced: true,
	state: {
		adminToken: "",
	},
	getters: {
		getToken: (state) => state.adminToken,
	},
	mutations: {
		//Save token
		saveToken: (state, token) => {
			state.adminToken = token;

			//Store it in the localStorage
			window.localStorage.setItem("adminAuthToken", token);
			//And use it in future requests
			axios.defaults.headers.common["AdminAuthorization"] = token;
		},
		removeToken: (state) => {
			state.adminToken = "";

			window.localStorage.removeItem("adminAuthToken");
			axios.defaults.headers.common["AdminAuthorization"] = "";
		},
	},
	actions: {
		//If the user logged in successfully, save token
		authSuccess: ({ commit }, token) => {
			commit("saveToken", token);
		},
		logoutSuccess: ({ commit }) => {
			commit("removeToken");
		},
	},
};

export default adminModule;
